import {
  doFetchProductDetails,
  doFetchPartPrice,
  doPatchOne,
  doFetchProductVariants,
  doFetchProductsAttributes,
} from "@/services/product.service";
import { getField, updateField } from "vuex-map-fields";

import {
  snakeToCamel,

} from "@/services/util.service";

export const productOne = {
  namespaced: true,
  state: {
    fetchInProgress: true,
    configuredProductProgress: true,
    productDetails: {},
    productMedia: {},
    errorMessage: null,
    productAttributes: {},
    configuredProductDetails: {},
    fetchPriceInProgress: false,
    staticDataOnProduct: null,
    fetchRewardsPointsInProgress: false,
    rewardsPoints: 0,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    setProductsDetails(state, details) {
      state.productDetails = details;
    },
    setStaticDataOnProduct(state, details) {
      state.staticDataOnProduct = details;
    },
    setProductsAttributes(state, list) {
      state.productAttributes = list;
    },
    setErrorMessage(state, err) {
      state.errorMessage = err;
    },
    setConfiguredProductDetails(state, details) {
      state.configuredProductDetails = details;
    },
    configuredProductProgress(state, yesOrNo) {
      state.configuredProductProgress = yesOrNo;
    },
    fetchPriceInProgress(state, yesOrNo) {
      state.fetchPriceInProgress = yesOrNo;
    },
    rewardsPointsInProgress(state, yesOrNo) {
      state.fetchRewardsPointsInProgress = yesOrNo;
    },
    setRewardsPoints(state, details) {
      if (details && details.data.potentialPoints) {
        state.rewardsPoints = details.data.potentialPoints;
      } else {
        state.rewardsPoints = 0;
      }
    },
  },
  actions: {
    fetchProductDetails: async ({ commit, dispatch }, { sku, productId }) => {
      try {
        commit("setErrorMessage", null);
        if (productId) {
          let fullCatalog = window.craneCatalog;
          const product = fullCatalog.products[productId];

          if (product) {
            commit("setProductsDetails", {
              id: product.productId,
              name: product.n,
              sku: product.sku,
              typeId: product.t,
              description: product.d,
              isPersonalize: product.ip,
              builderVersion: product.bv,
              price: product.p,
              mediaGalleryEntries: [{ mediaType: "image", file: product.i }],
              customAttribute: [],
            });
            if (product.t == "configurable") {
              commit("setConfiguredProductDetails", {
                items: [
                  {
                    mediaGalleryEntries: [
                      { mediaType: "image", file: product.i },
                    ],
                    customAttributes: [],
                  },
                ],
              });
            }
          }
        } else {
          commit("setStaticDataOnProduct", null);
        }
        if (sku) {
          commit("fetchInProgress", true);
          const productDetailsResponse = await doFetchProductDetails(sku);

          if (productDetailsResponse && productDetailsResponse.json) {
            const productDetails = await productDetailsResponse.json();
            if (Array.isArray(productDetails) && productDetails[0]) {
              const camelCasedProduct = snakeToCamel(productDetails[0]);
              commit("setProductsDetails", camelCasedProduct);
              let productDetailsNew = camelCasedProduct;
              commit("fetchInProgress", false);
              return snakeToCamel(productDetails[0]);
            } else {
              commit("fetchInProgress", false);
              throw new Error(`Product with SKU ${sku} not found or invalid`);
            }
          } else {
            commit("fetchInProgress", false);
            throw new Error(`Product with SKU ${sku} not found or invalid`);
          }
        }
      } catch (err) {
        commit("fetchInProgress", false);
        commit("setErrorMessage", err.message);
      }
    },
    fetchProductDetailsBySearch: async ({ commit, dispatch }, { sku }) => {
      try {
        commit("setErrorMessage", null);
        commit("fetchInProgress", true);
        const response = await doFetchProductDetails(sku);
        const productDetails = response.json
          ? (await response.json())[0]
          : null;
        if (productDetails) {
          commit("setProductsDetails", snakeToCamel(productDetails));
          let productDetailsNew = snakeToCamel(productDetails);

          commit("fetchInProgress", false);
          return productDetailsNew;
        }
      } catch (err) {
        commit("fetchInProgress", false);
      }
    },
    fetchProductAttribute: async ({ commit }, skuId) => {
      const productAttributes = await doFetchProductsAttributes(skuId);
      if (productAttributes) {
        commit("setProductsAttributes", snakeToCamel(productAttributes));
        return { productAttributes };
      }
    },

    fetchPartPrice: async ({ commit }, orderObject) => {
      try {
        commit("fetchPriceInProgress", true);
        let price = await doFetchPartPrice({ order: orderObject });
        commit("fetchPriceInProgress", false);
        return price;
      } catch (err) {
        commit("fetchPriceInProgress", false);
        throw err;
      }
    },
    fetchConfiguredProductDetails: async ({ commit }, sku) => {
      try {
        if (!sku) {
          return;
        }

        commit("configuredProductProgress", true);
        const configuredProductDetails = await doFetchProductVariants(sku);
        if (configuredProductDetails && configuredProductDetails.json) {
          const details = await configuredProductDetails.json();
          commit("setConfiguredProductDetails", details);
        }
        commit("configuredProductProgress", false);
      } catch (err) {
        commit("configuredProductProgress", false);
        throw err;
      }
    },
    fetchConfiguredProductDetailsUsingSku: async ({ commit, state }, sku) => {
      try {
        if (!sku) return;

        commit("configuredProductProgress", true);

        const details = state.productDetails.configurableProductLinks.filter(
          (x) => x.sku === sku
        );

        if (details.length > 0) {
          commit("setConfiguredProductDetails", {
            items: [details[0]],
          });
        } else {
          commit("setConfiguredProductDetails", { items: [] });
        }

        return details;
      } catch (err) {
        throw err;
      } finally {
        commit("configuredProductProgress", false);
      }
    },
    updateCatlog: async () => {
      try {
        await doPatchOne({ element: "catalog", requested_at: "" });
      } catch (err) {
        throw err;
      }
    },

  },
};
